import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import useHardwareFirstShop from '../hooks/useHardwareFirstShop';
import { shopPathForCollarPdp } from '../lib/legacyEntryShopPath';
import { useIsGift } from '../lib/util/isGift';

interface CollarPdpShopRedirectProps {
  productId: string;
  children: React.ReactNode;
}

/**
 * Sends an enrolled visitor from a collar pdp to the shop with that device preselected; everyone
 * else sees the pdp. The gift pdp stays, since the arm sells gifts from the cart toggle, not here.
 */
export default function CollarPdpShopRedirect({ productId, children }: CollarPdpShopRedirectProps) {
  const { search } = useLocation();
  const shopEnabled = useHardwareFirstShop();
  const isGift = useIsGift();
  const shopPath = shopEnabled && !isGift ? shopPathForCollarPdp(productId, search) : undefined;

  return shopPath ? <Redirect to={shopPath} /> : <>{children}</>;
}
